import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import cx from 'classnames';
import { withStyles, createStyles } from '@material-ui/core/styles';
import { darken, fade } from '@material-ui/core/styles/colorManipulator';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import Icon from '../../../../core/Icon';
import ThumbLoadingAnimation from './ThumbLoadingAnimation';
var THUMB_WIDTH = 190;
var THUMB_HEIGHT = 240;
var THUMB_CAPTION_HEIGHT = 28;

var styles = function styles(theme) {
  var _theme$getStyle = theme.getStyle('Data.Grid'),
      selectionColor = _theme$getStyle.selectionColor,
      contextMenuOpenedColor = _theme$getStyle.contextMenuOpenedColor,
      hoverColorBackground = _theme$getStyle.hoverColorBackground;

  selectionColor = theme.getColor(selectionColor);
  hoverColorBackground = theme.getColor(hoverColorBackground);
  return createStyles({
    root: {
      display: 'inline-block',
      width: THUMB_WIDTH,
      height: THUMB_HEIGHT,
      margin: 4,
      textAlign: 'center',
      verticalAlign: 'middle',
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.complex
      }),
      outline: 'none',
      '&:focus': {
        boxShadow: 'rgba(0, 0, 0, 0.2) 0px 1px 3px 0px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 2px 1px -1px'
      }
    },
    noElevationRoot: {
      '&:focus': {
        boxShadow: 'none'
      }
    },
    deleted: {
      opacity: 0.2
    },
    updating: {
      opacity: 0.5
    },
    paper: {
      position: 'relative',
      border: '2px solid transparent',
      backgroundColor: 'white',
      '&:hover': {
        borderColor: hoverColorBackground,
        cursor: 'pointer',
        boxShadow: '0 10px 20px rgb(0 0 0 / 25%), 0 8px 8px rgb(0 0 0 / 15%)'
      }
    },
    noElevationPaper: {
      backgroundColor: 'inherit'
    },
    selectedPaper: {
      borderColor: selectionColor,
      cursor: 'pointer'
    },
    contextMenuOpenedPaper: {
      borderColor: contextMenuOpenedColor + ' !important'
    },
    noElevation: {
      border: "1px solid ".concat(theme.palette.divider),
      background: theme.palette.background.paper,
      '&:hover': {
        borderColor: fade(selectionColor, 0.85)
      },
      '$selectedPaper &': {
        borderColor: selectionColor
      }
    },
    imageWrapper: {
      height: THUMB_HEIGHT - THUMB_CAPTION_HEIGHT - 4,
      width: THUMB_WIDTH - 4
    },
    innerImageWrapper: {
      position: 'absolute',
      width: 'inherit',
      height: 'inherit'
    },
    image: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      maxWidth: '98%',
      maxHeight: '98%',
      textAlign: 'center',
      width: '100%'
    },
    title: {
      lineHeight: THUMB_CAPTION_HEIGHT + 'px',
      textAlign: 'left',
      fontSize: 12,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      display: 'inherit',
      bottom: -1,
      left: -2,
      width: 'calc(100% + 4px)',
      position: 'relative'
    },
    selectedTitle: {
      backgroundColor: selectionColor,
      color: '#FFFFFF'
    },
    hoveredTitle: {
      backgroundColor: hoverColorBackground,
      color: '#FFFFFF'
    },
    contextMenuOpenedTitle: {
      backgroundColor: contextMenuOpenedColor,
      color: theme.palette.getContrastText(contextMenuOpenedColor)
    },
    icon: {
      fontSize: 15,
      marginLeft: 6,
      marginRight: 6,
      overflow: 'visible'
    },
    text: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      maxWidth: '100%',
      display: 'inline-block',
      verticalAlign: 'middle'
    },
    ctxMenuIcon: {
      fontSize: 18,
      display: 'block',
      cursor: 'pointer'
    }
  });
};
/**
 * @extends {React.Component<import('./types').GridViewImageProps & import('@material-ui/core').WithStyles<typeof styles>> }
 */


var GridViewImage =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GridViewImage, _React$Component);

  function GridViewImage() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, GridViewImage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(GridViewImage)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      imgLoaded: false
    };

    _this.onLoaded = function () {
      _this.setState({
        imgLoaded: true
      });
    };

    _this.onContextMenuButton = function (e) {
      return _this.props.onContextMenu(e, {
        origin: 'button'
      });
    };

    return _this;
  }

  _createClass(GridViewImage, [{
    key: "render",
    value: function render() {
      var _cx, _cx2;

      var _this$props = this.props,
          icon = _this$props.icon,
          url = _this$props.url,
          text = _this$props.text,
          style = _this$props.style,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseLeave = _this$props.onMouseLeave,
          onMouseOver = _this$props.onMouseOver,
          onContextMenu = _this$props.onContextMenu,
          classes = _this$props.classes,
          selected = _this$props.selected,
          hovered = _this$props.hovered,
          onClick = _this$props.onClick,
          onDoubleClick = _this$props.onDoubleClick,
          elevation = _this$props.elevation,
          showContextMenuIcon = _this$props.showContextMenuIcon,
          contextMenuOpened = _this$props.contextMenuOpened,
          deleted = _this$props.deleted,
          updating = _this$props.updating,
          width = _this$props.width,
          height = _this$props.height,
          rest = _objectWithoutProperties(_this$props, ["icon", "url", "text", "style", "onMouseEnter", "onMouseLeave", "onMouseOver", "onContextMenu", "classes", "selected", "hovered", "onClick", "onDoubleClick", "elevation", "showContextMenuIcon", "contextMenuOpened", "deleted", "updating", "width", "height"]);

      var iconProps = {
        className: classes.icon,
        style: {
          opacity: icon ? 1 : 0,
          verticalAlign: 'middle'
        }
      };

      if (typeof icon === 'object') {
        iconProps = _objectSpread({}, iconProps, icon);
      } else if (typeof icon === 'string') {
        iconProps = _objectSpread({}, iconProps, {
          type: icon ? icon : 'loading'
        });
      }

      var styleProps = {
        width: width ? width : '',
        height: height ? height : ''
      };
      var paperProps = {
        square: true,
        classes: {
          root: classes.paper
        },
        elevation: elevation,
        onClick: onClick,
        onDoubleClick: onDoubleClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseOver: onMouseOver,
        onContextMenu: onContextMenu
      };
      if (selected) paperProps.classes.root += ' ' + classes.selectedPaper;
      if (contextMenuOpened) paperProps.classes.root += ' ' + classes.contextMenuOpenedPaper;
      if (elevation === 0) paperProps.classes.root += ' ' + classes.noElevationPaper;
      return React.createElement("div", {
        className: cx(classes.root, (_cx = {}, _defineProperty(_cx, classes.deleted, deleted), _defineProperty(_cx, classes.updating, updating), _defineProperty(_cx, classes.noElevationRoot, elevation === 0), _cx)),
        style: styleProps
      }, React.createElement(Paper, paperProps, React.createElement("div", {
        className: elevation === 0 ? classes.noElevation : ''
      }, React.createElement("div", {
        className: classes.imageWrapper,
        style: {
          width: width ? width - 8 : '',
          height: height ? height - THUMB_CAPTION_HEIGHT : ''
        }
      }, React.createElement("div", {
        className: classes.innerImageWrapper
      }, !this.state.imgLoaded && React.createElement(ThumbLoadingAnimation, null), React.createElement("img", {
        className: classes.image,
        src: url,
        style: style,
        onLoad: this.onLoaded,
        onError: this.onLoaded
      }))), React.createElement("div", {
        className: cx((_cx2 = {}, _defineProperty(_cx2, classes.title, true), _defineProperty(_cx2, classes.selectedTitle, selected), _defineProperty(_cx2, classes.hoveredTitle, hovered), _defineProperty(_cx2, classes.contextMenuOpenedTitle, contextMenuOpened), _cx2))
      }, React.createElement(Grid, {
        container: true,
        direction: "row",
        justify: "space-between",
        alignItems: "center"
      }, React.createElement(Grid, {
        item: true
      }, React.createElement(Icon, iconProps)), React.createElement(Grid, {
        item: true,
        xs: true,
        zeroMinWidth: true
      }, React.createElement(Typography, {
        color: "inherit"
      }, React.createElement("span", {
        className: classes.text,
        title: text
      }, text))), showContextMenuIcon && React.createElement(Grid, {
        item: true,
        onClick: this.onContextMenuButton
      }, React.createElement(Icon, {
        className: classes.ctxMenuIcon,
        mini: true,
        type: "more"
      })))))));
    }
  }]);

  return GridViewImage;
}(React.Component);

GridViewImage.defaultProps = {
  selected: false,
  elevation: 4,
  hovered: false,
  showContextMenuIcon: false,
  contextMenuOpened: false,
  deleted: false,
  updating: false,
  style: {}
};
export default withStyles(styles, {
  name: 'ECGridViewImage'
})(GridViewImage);